export const downtimeTableHeaders = [
    {
      id: "bankName",
      label: "Bank / Specifications",
      mobile: 4,
    },
    {
      id: "category",
      label: "Bank Type",
      mobile: 2,
    },
    {
      id: "downSinceTime",
      label: "Start Time",
      customCell: {
        type: "date",
        showTime: true
      },
    },
    {
      id: "upFromTime",
      label: "End Time",
      mobile: 1,
      customCell: {
        type: "date",
        showTime: true
      },
    },
    {
      id: "duration",
      label: "Duration",
      mobile: 3,
    },
  ];

export const getActiveDowntime = (downtimeList = []) => {
  return downtimeList.filter(d => d.isCurrentlyDown);
}
export const getPastDowntime = (downtimeList = []) => {
  return downtimeList.filter(d => !d.isCurrentlyDown);
}